// extracted by mini-css-extract-plugin
export var linkText = "_lz-0";